/**
 * User settings — Supabase
 * Notification preferences: opt-out model — all types on by default.
 */

import { supabase, TABLES } from './db';
import { NotificationType } from '../types';

export const DEFAULT_NOTIFICATION_PREFERENCES: Record<NotificationType, boolean> = {
  connection_request: true,
  connection_accepted: true,
  connection_rejected: true,
  new_message: true,
  task_update: true,
  task_assigned: true,
  task_completed: true,
  system: true,
};

export async function getMergedNotificationPreferences(
  userId: string
): Promise<Record<NotificationType, boolean>> {
  const { data } = await supabase
    .from(TABLES.USER_SETTINGS)
    .select('notification_preferences')
    .eq('user_id', userId)
    .maybeSingle();

  const partial = (data?.notification_preferences as Partial<Record<NotificationType, boolean>>) ?? {};
  return { ...DEFAULT_NOTIFICATION_PREFERENCES, ...partial };
}

export async function isNotificationTypeEnabled(
  userId: string,
  type: NotificationType
): Promise<boolean> {
  const prefs = await getMergedNotificationPreferences(userId);
  return prefs[type] !== false;
}

export async function saveNotificationPreferences(
  userId: string,
  patch: Partial<Record<NotificationType, boolean>>
): Promise<void> {
  const current = await getMergedNotificationPreferences(userId);
  const next: Record<NotificationType, boolean> = { ...current, ...patch };
  const now = new Date().toISOString();

  const { error } = await supabase.from(TABLES.USER_SETTINGS).upsert(
    { id: userId, user_id: userId, notification_preferences: next, updated_at: now },
    { onConflict: 'id' }
  );
  if (error) throw error;
}
